/**
 * Check if market is QA
 * @param {Market} market Market to process
 * @return {boolean}
 */
export const isMarketQA = (market) => market.id
    ? market.id.indexOf("_") < 0
    : false;
//# sourceMappingURL=isMarketQA.js.map